export const getStyleProperty = (property: string, element: HTMLElement = document.documentElement): string =>
    window.getComputedStyle(element).getPropertyValue(property)
